/** @jsxImportSource react */
import type { SVGProps } from 'react';
const Close = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="M4.97 17.97a.75.75 0 1 0 1.06 1.06L12 13.06l5.97 5.97a.75.75 0 1 0 1.06-1.06L13.06 12l5.97-5.97a.75.75 0 0 0-1.06-1.06L12 10.94 6.03 4.97a.75.75 0 0 0-1.06 1.06L10.94 12z"
    />
  </svg>
);
export default Close;
